<template>
  <div class="sq-footer">
    Email v1.0.42 by
    <a href="https://www.github.com/stevenlafl">stevenlafl</a>
  </div>
</template>

<style scoped>
.sq-footer {
  background-color: #add8e6;
  height: 20px;
  font-size: 12px;
  display: flex;
  justify-content: flex-end;
  color: white;
  align-items: center;
  padding-right: 1em;
}
a {
  color: white;
}
</style>

<script>
export default {
  name: "sqreen-footer"
};
</script>
